import api from "../../../utilidades/interceptor";
const urlApi = process.env.REACT_APP_API_KEY;

export const addNovedad = async (data) => {
    try {
        const result = await api.post(`${urlApi}/innovationDevelopment/addNewness`, data);
        return result.data;

    } catch (error) {
        console.log("error", error);
    }
}
